var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80",
    width: "80px",
    height: "80px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface152449812"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.549021%,92.54902%,80.784315%)",
      fillOpacity: 1
    },
    d: "M 70 61.667969 C 70 66.269531 66.269531 70 61.667969 70 L 18.332031 70 C 13.730469 70 10 66.269531 10 61.667969 L 10 18.332031 C 10 13.730469 13.730469 10 18.332031 10 L 61.667969 10 C 66.269531 10 70 13.730469 70 18.332031 Z M 70 61.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.921569%,9.803922%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 55.050781 42.667969 C 53.964844 41.167969 52.398438 40.132812 50.382812 39.582031 C 50.382812 39.582031 52.082031 38.964844 53.617188 36.667969 C 54.535156 35.199219 55 33.433594 55 31.367188 C 55 27.785156 53.699219 25.035156 51.101562 23.148438 C 48.5 21.265625 45.566406 20 40.582031 20 L 25 20 L 25 60 L 42.382812 60 C 47.101562 59.964844 50.648438 58.949219 53.066406 57 C 55.464844 55.015625 56.667969 52.082031 56.667969 48.167969 C 56.667969 46 56.132812 44.167969 55.050781 42.667969 Z M 35 26.667969 C 35 26.667969 41.949219 26.667969 42.082031 26.667969 C 44.617188 26.667969 46.667969 28.714844 46.667969 31.25 C 46.667969 33.785156 44.617188 35.832031 42.082031 35.832031 C 41.949219 35.832031 35 35.832031 35 35.832031 Z M 43.332031 53.332031 L 35 53.332031 L 35 43.332031 L 43.332031 43.332031 C 46.101562 43.332031 48.332031 45.566406 48.332031 48.332031 C 48.332031 51.101562 46.101562 53.332031 43.332031 53.332031 Z M 43.332031 53.332031 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.daa56f579af5d0b549ffe0f0e6beed00.svg";
export { ForwardRef as ReactComponent };